import React from 'react'
import axios from 'axios'
import { Link } from 'react-router-dom'

import Interno from './Interno'

export default class Suporte extends React.Component {
    constructor(props) {
        super(props)
        this.state = {

        }
    }

    save(e) {
        e.preventDefault()
        const url = '/api/ficha/social'
        const ficha = this.state.ficha
        axios.post(url, ficha)
            .then(res => {
                alert('Ficha enviada com sucesso!')
                window.location = `/documentos/${this.props.match.params.id}`
            })
            .catch(error => {
                alert(error.response.data)
            })
    }

    updateField(event) {
        const ficha = { ...this.state.ficha }
        ficha[event.target.name] = event.target.value
        this.setState({ ficha })
    }

    render() {
        if(localStorage.tipo == 'interno') {
            return <Interno />
        }
        return (
            <React.Fragment>
                <Link to='/novoChamado'>
                    <div className="ficha protocolos col-md-12 col-lg-4 d-inline-block">
                        <i class="fas fa-microphone verdeUnimed icone"></i>
                        <b className="verdeUnimed">NOVO CHAMADO</b>
                    </div>
                </Link>
                
                <Link to='/meusChamados'>
                    <div className="ficha protocolos col-md-12 col-lg-4 d-inline-block">
                        <i class="fas fa-phone-volume verdeUnimed icone"></i>
                        <b className="verdeUnimed">MEUS CHAMADOS</b>
                    </div>
                </Link>
            </React.Fragment>
        )
    }
}